import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-66q-32 0-56-23-23-24-23-56v-610q0-33 23-56 24-24 56-24h60v-23q0-15 11-26t26-11q16 0 27 11t11 26v23h320v-23q0-15 11-26t27-11q15 0 26 11t11 26v23h60q33 0 56 24 24 23 24 56v610q0 32-24 56-23 23-56 23H185Zm0-79h590v-425H185v425Zm0-485h590v-125H185v125Zm0 0v-125 125Z"/>',
  f: '<path d="M185-66q-32 0-56-23-23-24-23-56v-610q0-33 23-56 24-24 56-24h60v-23q0-15 11-26t26-11q16 0 27 11t11 26v23h320v-23q0-15 11-26t27-11q15 0 26 11t11 26v23h60q33 0 56 24 24 23 24 56v610q0 32-24 56-23 23-56 23H185Zm0-79h590v-425H185v425Z"/>',
};

export default data;
